import { PDFDocument, PDFName, PDFRawStream, decodePDFRawStream } from 'pdf-lib';

// Los PDF/A (cualquier variante: 1, 2, 3 y 4) no admiten insertar firmas y la API los rechaza.
// Se detectan al elegir el archivo para avisar antes de subirlo, con la misma regla que usa la
// API (iText): el PDF declara su norma en el XMP del catálogo (pdfaid:part y pdfaid:conformance).
export const PDFA_NOT_SUPPORTED_MESSAGE =
  'El documento está en formato PDF/A, el cual no permite insertar firmas. Guárdalo como PDF estándar (sin PDF/A) e intenta de nuevo.';

const CONFORMANCE_BY_PART = {
  1: ['A', 'B'],
  2: ['A', 'B', 'U'],
  3: ['A', 'B', 'U'],
};

function xmpValue(xmp, name) {
  // El XMP puede traer el valor como atributo (pdfaid:part="1") o como elemento (<pdfaid:part>1</pdfaid:part>).
  const match = xmp.match(new RegExp(`pdfaid:${name}\\s*=\\s*["']([^"']*)["']|<pdfaid:${name}>([^<]*)<`));
  return match ? (match[1] !== undefined ? match[1] : match[2]).trim() : null;
}

function declaresPdfA(xmp) {
  const part = xmpValue(xmp, 'part');
  if (part === '4') return true;
  const conformance = (xmpValue(xmp, 'conformance') || '').toUpperCase();
  return (CONFORMANCE_BY_PART[part] || []).includes(conformance);
}

export async function isPdfA(file) {
  try {
    const pdf = await PDFDocument.load(await file.arrayBuffer(), { ignoreEncryption: true, updateMetadata: false });
    const metadata = pdf.catalog.lookup(PDFName.of('Metadata'));
    if (!(metadata instanceof PDFRawStream)) return false;
    return declaresPdfA(new TextDecoder().decode(decodePDFRawStream(metadata).decode()));
  } catch (e) {
    // Si el navegador no logra leerlo, la API decide al subirlo.
    return false;
  }
}
